"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializedModeStateSchema = void 0;
const zod_1 = require("zod");
const ModeStateType_1 = require("../DesignModels/ModeStateType");
exports.SerializedModeStateSchema = zod_1.default.union([
    zod_1.default.boolean(),
    zod_1.default.literal(ModeStateType_1.ModeStateType.Indeterminate),
]);
//# sourceMappingURL=SerializedModeState.js.map